'use client';
import React from 'react';

const techRow1 = [
  { name: 'React', color: '#61DAFB', emoji: '⚛️' },
  { name: 'Next.js', color: '#96BF48', emoji: '▲' },
  { name: 'Vue.js', color: '#42B883', emoji: '🟢' },
  { name: 'Angular', color: '#DD0031', emoji: '🅰️' },
  { name: 'TypeScript', color: '#3178C6', emoji: '📘' },
  { name: 'Framer Motion', color: '#0055FF', emoji: '🎞️' },

  { name: 'Node.js', color: '#68A063', emoji: '🟩' },
  { name: 'Laravel', color: '#FF2D20', emoji: '🔴' },
  { name: 'Django', color: '#FF61F6', emoji: '🌿' },
  { name: 'Python', color: '#FFD43B', emoji: '🐍' },
  { name: 'Java', color: '#007396', emoji: '☕' },
  { name: 'GraphQL', color: '#E10098', emoji: '🔺' },

  { name: 'Flutter', color: '#02569B', emoji: '🦋' },
  { name: 'React Native', color: '#61DAFB', emoji: '📱' },
  { name: 'Android', color: '#3DDC84', emoji: '🤖' },

  { name: 'Docker', color: '#2496ED', emoji: '🐳' },
  { name: 'AWS', color: '#FF9900', emoji: '☁️' },
  { name: 'Oracle Cloud', color: '#F80000', emoji: '🌩️' },

  { name: 'Medusa', color: '#326CE5', emoji: '🛒' },
];

const techRow2 = [
  { name: 'PostgreSQL', color: '#336791', emoji: '🐘' },
  { name: 'MySQL', color: '#4479A1', emoji: '🐬' },
  { name: 'MongoDB', color: '#47A248', emoji: '🍃' },
  { name: 'Redis', color: '#DC382D', emoji: '🧠' },

  { name: 'Figma', color: '#F24E1E', emoji: '🎨' },
  { name: 'Adobe XD', color: '#FF61F6', emoji: '🟣' },
  { name: 'Photoshop', color: '#31A8FF', emoji: '🖼️' },
  { name: 'After Effects', color: '#9999FF', emoji: '🎬' },
  { name: 'Premiere Pro', color: '#9999FF', emoji: '🎞️' },

  { name: 'WordPress', color: '#21759B', emoji: '📰' },
  { name: 'Shopify', color: '#96BF48', emoji: '🛒' },
  { name: 'Magento', color: '#EE672F', emoji: '🛍️' },
  { name: 'Joomla', color: '#5091CD', emoji: '🔷' },
  { name: 'Drupal', color: '#D24939', emoji: '🌐' },

  { name: 'Stripe', color: '#635BFF', emoji: '💳' },
  { name: 'Firebase', color: '#FFCA28', emoji: '🔥' },
  { name: 'Supabase', color: '#3ECF8E', emoji: '🟢' },

  { name: 'GitHub Actions', color: '#2088FF', emoji: '⚙️' },
  { name: 'Nginx', color: '#009639', emoji: '🌍' },
];

interface TechBadgeProps {
  name: string;
  color: string;
  emoji: string;
}

function TechBadge({ name, color, emoji }: TechBadgeProps) {
  return (
    <div
      className="tech-badge mx-2 flex-shrink-0"
      style={{
        borderColor: `${color}30`,
        background: `${color}10`,
      }}
    >
      <span style={{ fontSize: '1rem' }}>{emoji}</span>
      <span style={{ color: color }}>{name}</span>
    </div>
  );
}

export default function TechStackSection() {
  const row1Doubled = [...techRow1, ...techRow1];
  const row2Doubled = [...techRow2, ...techRow2];

  return (
    <section id="stack" className="py-16 lg:py-20 relative overflow-hidden">
      <div className="section-divider mb-16" />

      <div className="max-w-7xl mx-auto px-6 mb-12 text-center initially-hidden animate-in">
        <div className="section-label mb-3">Tech Arsenal</div>
        <h2
          className="text-3xl md:text-4xl font-bold"
          style={{ color: 'var(--text-primary)', letterSpacing: '-0.03em' }}
        >
          Technologies I Utilize
        </h2>
      </div>

      {/* Row 1 — Left to right */}
      <div className="relative overflow-hidden mb-4">
        <div
          className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to right, var(--bg-primary), transparent)',
          }}
        />
        <div
          className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to left, var(--bg-primary), transparent)',
          }}
        />
        <div className="marquee-track">
          {row1Doubled.map((tech, i) => (
            <TechBadge key={`r1-${i}`} {...tech} />
          ))}
        </div>
      </div>

      {/* Row 2 — Right to left */}
      <div className="relative overflow-hidden">
        <div
          className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to right, var(--bg-primary), transparent)',
          }}
        />
        <div
          className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to left, var(--bg-primary), transparent)',
          }}
        />
        <div className="marquee-track-reverse">
          {row2Doubled.map((tech, i) => (
            <TechBadge key={`r2-${i}`} {...tech} />
          ))}
        </div>
      </div>

      <div className="section-divider mt-16" />
    </section>
  );
}
